import { Component, Injectable, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CreateUser } from '../models/create-user.model';
import { UserService } from '../services/user.service';

@Component({
    selector: 'create-user',
    templateUrl: './create-user.component.html',
    standalone: false
})

export class CreateUserComponent {

    createUser: CreateUser = new CreateUser();

    constructor(
        private router: Router,
        public userService: UserService) { }


    ngOnInit(): void {
        console.log("ngOnInit()");
    }

    create() {        
        this.userService.createUser(this.createUser).then(() => {
            this.router.navigate(['/listUsers']);
        }, (error) => {
            console.log(error);
            alert('Something went wrong.');
        });
    }

}
